import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

export const deleteCustomPrice = async (
  scope: RequestScope,
  { itemId, id }: { itemId: number; id: number },
  options: WriteRequestOptions
): Promise<EndpointResponse<unknown>> => {
  try {
    const response = await scopedApi(scope).delete<EndpointResponse<unknown>>(`pricing_item/${itemId}/custom_pricing/${id}`, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error);
  }
};
